import {toIsoDateString} from "./to-iso-date-string";
import {addDaysInZone} from "./add-days-in-zone";
import {dateToUtc} from "./date-to-utc";

/**
 * @hidden
 */
export function toInclusiveEndIsoDateString(date: Date | string, zone: string, truncate?: boolean): string

/**
 * @hidden
 */
export function toInclusiveEndIsoDateString(date: undefined, zone: string, truncate?: boolean): undefined

/**
 * @hidden
 */
export function toInclusiveEndIsoDateString(date: null, zone: string, truncate?: boolean): null

/**
 * @hidden
 */
export function toInclusiveEndIsoDateString(date: Date | string | undefined, zone: string, truncate?: boolean): string | undefined

/**
 * @hidden
 */
export function toInclusiveEndIsoDateString(date: Date | string | null, zone: string, truncate?: boolean): string | null

/**
 * Works like {@link toIsoDateString} except if the argument is a {@link Date} (i.e. is a date time) then it will be converted
 * into a date for the previous date. This is because when representing an end as a date time, it is end *exclusive* but as a date it
 * is end *inclusive*. For example if the argument is `new Date('2022-12-31T:11:00:00Z')` and the zone is 'Pacific/Auckland' (the exclusive
 * end of 2022 in NZ) then it will be converted into the string '2022-12-31'.
 *
 * @param date
 * @param zone the time zone descriptor, usually an offset or IANA time zone name (e.g. America/Los_Angeles)
 */
export function toInclusiveEndIsoDateString(date: Date | string | undefined | null, zone: string, truncate?: boolean): string | undefined | null

export function toInclusiveEndIsoDateString(date: Date | string | undefined | null, zone: string, truncate?: boolean): string | undefined | null {
  if (typeof date === 'undefined') {
    return undefined
  } else if (date === null) {
    return null
  } else if (typeof date === 'string') {
    return toIsoDateString(date, zone, truncate);
  } else {
    // isDate(date) is true
    // date is to date time exclusive and result needs to be date inclusive
    // we need to minus 1 day
    return toIsoDateString(addDaysInZone(dateToUtc(date, zone, truncate), -1, zone), zone);
  }
}
